<div class="page-cardhead-wrap" [style.--page-card-max-width.px]="pageHeaderMaxWidth">
  <div class="card-holder card pt-0">
    <div class="card-body page-card rounded-2 shadow-3-strong text-center" #pageCardHeader>
      <span class="page-card-title">{{ PageName }}</span>
    </div>
  </div>
</div>
